@if (filter.values?.length; as optionsCount) {
  <div class="equipment-filter"
       [ngClass]="{'is-open': filter.activeValue?.length || isFilterOpened}">
    <button type="button"
        class="button-filter"
        [attr.data-test]="'button-filter-' + filter.name"
        (click)="toggleFilterOptions()">
      {{ filter.localizedName }}
    </button>
    <div class="filter-options">
      <div class="search-field textfield textfield--with-prefix">
        <span class="textfield__prefix icon-search"></span>
        <input type="search"
               [attr.data-test]="'input-filterSelect-' + filter.name"
            class="textfield__input search-field__input"
            spellcheck="false"
            autocomplete="off"
            [id]="'item_search' + filter.name"
            [name]="'search' + filter.name"
            placeholder="{{ 'advanced-filter.search' | translate }} {{ filter.localizedName }}"
            [(ngModel)]="filterSearchValue"
            (keydown.enter)="$event.preventDefault()">
        <label for="search" class="search-bar__label"></label>
      </div>
      <ul class="filter-options-list">
        @if (!isPredefinedEquipmentFlowEnabled && optionsCount > 1) {
          <li class="all-options-item">
            <input type="checkbox"
                   [attr.data-test]="'input-filterCheckbox-' + filter.name"
                class="checkbox"
                [id]="'select-all-' + filter.name"
                [name]="'checkbox-all-' + filter.name"
                [checked]="areOptionsSelected()"
                (click)="selectOptionsOrClear()">
            <label [for]="'select-all-' + filter.name">
              {{ 'filters.equipment-filter.select-all-or-clear' | translate }}
            </label>
          </li>
        }
        @for (item of filteredOptions; track item.key) {
          <li class="option-item"
              [attr.data-test]="'desc-option-' + item.option.value">
            <input type="checkbox"
                   [attr.data-test]="'input-filterCheckbox-' + item.key"
                class="checkbox"
                [id]="item.key"
                [name]="item.key"
                [checked]="item.selected"
                (click)="selectOption(item.option)">
            <label [for]="item.key">
              <span [attr.data-test]="'desc-optionName'">
                {{ item.option.value }}
                @if (isEnhancedEquipmentTypeFilterEnabled) {
                  ({{ item.option['rel-product-sysivk'] }})
                }
              </span>
            </label>
          </li>
        }
      </ul>
    </div>
  </div>
}
